// "New" card flag: re-checks the launch window against the visitor's clock, since Shopify
// may serve a cached page rendered before the window opened or after it closed.
if (!customElements.get('ma-new-flag')) {
  customElements.define(
    'ma-new-flag',
    class MaNewFlag extends HTMLElement {
      connectedCallback() {
        const now = Date.now() / 1000;
        this.hidden = !(now >= Number(this.dataset.start) && now < Number(this.dataset.end));
      }
    }
  );
}
